'use client';

import styled from 'styled-components';

import type { HeadingTwoElementType } from '@zoomit/editor';
import { Spacing } from '@zoomit/primitives';
import { Typography } from '@zoomit/zoomit-ds';

import { isMobile } from '../../../constants/media-query';
import HeadingLink from './HeadingLink';

interface RenderElementProps {
  children: any;
  element: HeadingTwoElementType;
  id?: string;
}

const HeadingTwo = (props: RenderElementProps) => {
  const { children, element, id } = props;

  return (
    <Root>
      {!isMobile && id && <HeadingLink id={id} />}
      <HeadingTwoBase
        variant="h2"
        lineHeight={1.78}
        textAlign={element.annotations.textAlign}
        textDir={element.annotations.textDirection}
        id={id}
      >
        {children}
      </HeadingTwoBase>
    </Root>
  );
};

export default HeadingTwo;

type HeadingTwoProps = {
  textAlign?: string;
  textDir?: string;
};

const Root = styled.div`
  position: relative;

  &:hover {
    & > div {
      visibility: visible;
      opacity: 1;
    }
  }
`;

const HeadingTwoBase = styled(Typography)<HeadingTwoProps>`
  font-size: 2.2rem;
  scroll-margin: 6.8rem;
  margin-bottom: ${Spacing.x4}rem;
  text-align: ${({ textAlign }) => textAlign};
  direction: ${({ textDir }) => textDir};
`;
